module.exports = __webpack_public_path__ + "img/banner.480f6d82.png";